import Ship from './ship.js';

export default class PatrolBoat extends Ship {
  constructor() {
    super(2, 'patrol_boat');
  }
}
